import { Controller } from '@hotwired/stimulus'
const FAUX_LOADING_MS = 300

// Connects to data-controller="plan-documents-display"
export default class extends Controller {
  static targets = [
    'loadingIcon',
    'planYearSelect',
    'documentRow',
  ]

  declare readonly loadingIconTarget: HTMLElement
  declare readonly planYearSelectTarget: HTMLSelectElement
  declare readonly documentRowTargets: HTMLElement[]

  connect () {
    this.planYearSelectTarget.addEventListener('change', this.updatePlanYear)
  }

  updatePlanYear = (): void => {
    this.loadingIconTarget.classList.remove('hidden')
    setTimeout(() => this.loadingIconTarget.classList.add('hidden'), FAUX_LOADING_MS)
    const selectedYear = this.planYearSelectTarget.value
    this.documentRowTargets.forEach(el => {
      el.querySelectorAll<HTMLAnchorElement>('a[href]').forEach(link => {
        this.flashLoadingAnimation(link)
        this.updateLinkYear(link, selectedYear)
      })

      setTimeout(() => this.checkToHideOrDisplayDocument(el, selectedYear), FAUX_LOADING_MS)
    })
  }

  private flashLoadingAnimation = (link: HTMLAnchorElement) => {
    link.classList.add('animate-pulse', 'bg-gray-200', 'text-transparent', 'rounded')
    setTimeout(() => link.classList.remove('animate-pulse', 'bg-gray-200', 'text-transparent', 'rounded'), FAUX_LOADING_MS)
  }

  private updateLinkYear = (link: HTMLAnchorElement, selectedYear: string) => {
    const existingPath = link.href
    const newPath = existingPath.replace(/documents\/\d{4}/, `documents/${selectedYear}`)
    link.href = newPath
  }

  private checkToHideOrDisplayDocument = (el: HTMLElement, selectedYear: string) => {
    const yearToDisplayRow = el.getAttribute('data-plan-documents-display-display-for-year')
    if (yearToDisplayRow === selectedYear) {
      el.classList.remove('hidden')
    } else if (yearToDisplayRow !== 'all' && yearToDisplayRow !== selectedYear) {
      el.classList.add('hidden')
    }
  }
}
